// extracted by mini-css-extract-plugin
module.exports = {"hero":"HeroImage_hero__syuSq"};